import { EventEmitter } from "events";

const createUUID = () => {
  const pattern = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
  return pattern.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

const Constants = {
  CHANGE: "change",
  FLOAT: "float",
  HIDING: "hiding"
};

class HUGuideTableManager extends EventEmitter {
  constructor(props) {
    super(props);
    this.notify = {};
  }

  create(notify) {
    const defaultNotify = {
      /// setup default property
      id: createUUID(),
      isShow: false,
      type: "change",
      timeOut: 5000
    };

    this.notify = Object.assign(defaultNotify, notify);

    this.emitChange();
  }

  floating(timeOut, onClick) {
    this.create({
      type: Constants.FLOAT,
      isShow: true,
      timeOut,
      onClick
    });
  }

  hiding(timeOut, onClick) {
    this.create({
      type: Constants.HIDING,
      isShow: false,
      timeOut,
      onClick
    });
  }

  remove() {
    this.notify = {};
    this.emitChange();
  }

  emitChange() {
    this.emit(Constants.CHANGE, this.notify);
  }

  addChangeListener(callback) {
    this.addListener(Constants.CHANGE, callback);
  }

  removeChangeListener(callback) {
    this.removeListener(Constants.CHANGE, callback);
  }
}

export default new HUGuideTableManager();
